import { render } from "./TimeTravelDebugger.vue?vue&type=template&id=1f072344&scoped=true"
import script from "./TimeTravelDebugger.vue?vue&type=script&lang=js"
export * from "./TimeTravelDebugger.vue?vue&type=script&lang=js"

import "./TimeTravelDebugger.vue?vue&type=style&index=0&id=1f072344&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f072344"]])

export default __exports__